// import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ReleaseRequest } from './models/request/release.request';
import { ReleaseResponse } from './models/response/release.response';
import { RequestState } from '@shared/models/request-state';
import { ApiCacheService } from '@shared/services/api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class ReleaseService {
  private readonly _url = `${environment.apiUrl}release`;

  constructor(private cacheService: ApiCacheService) {}

  getRelease(
    releaseRequest: ReleaseRequest,
    isRefresh = false
  ): Observable<RequestState<ReleaseResponse>> {
    const cacheId = this.getCacheId(releaseRequest);
    const { flightNumber, date, depStation } = releaseRequest;
    const url = `${this._url}/${flightNumber}/${date}/${depStation}`;

    if (isRefresh) {
      return this.cacheService.forceRefreshGet<ReleaseResponse>(cacheId, url);
    } else {
      return this.cacheService.request<ReleaseResponse>(cacheId, url);
    }
  }

  private getCacheId(releaseRequest: ReleaseRequest): string {
    const { flightNumber, date, depStation } = releaseRequest;
    return `release-${flightNumber}/${date}/${depStation}`;
  }
}
